// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var TypeDeduction$XodProject = require("./TypeDeduction.bs.js");

function deducePinTypes(patch, project) {
  return TypeDeduction$XodProject.ResultsMap.toJsDict(TypeDeduction$XodProject.deducePinTypes(patch, project));
}

exports.deducePinTypes = deducePinTypes;
/* TypeDeduction-XodProject Not a pure module */
